module.exports = __webpack_public_path__ + "static/img/186_TO8_2054.fbb30e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/186_TO8_2054.jpg
// module id = LDn/
// module chunks = 0